import { createSlice } from '@reduxjs/toolkit';

export interface IJupyterState {
  ideRunProjectId: string
}

const initialState: IJupyterState = {
  ideRunProjectId: ''
};
export const ideSlice = createSlice({
  name: 'ide',
  initialState,
  reducers: {
    updateRunProjectId: (state, action) => {
      state.ideRunProjectId = action.payload.ideRunProjectId
    },
  }
});

export const { updateRunProjectId } = ideSlice.actions;
export default ideSlice.reducer;
